const COOKIE = "bigcircle_visitor_id";
const valid = (value) =>
  /^bc_anon_[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
    value || "",
  );
export const getVisitorId = () => {
  const value = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(COOKIE + "="))
    ?.split("=")[1];
  return valid(value) ? value : null;
};
export const ensureVisitorId = () => {
  let value = getVisitorId();
  if (!value) {
    // getRandomValues also works on local LAN development origins without randomUUID.
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join(
      "",
    );
    value =
      "bc_anon_" +
      [
        hex.slice(0, 8),
        hex.slice(8, 12),
        hex.slice(12, 16),
        hex.slice(16, 20),
        hex.slice(20),
      ].join("-");
    document.cookie =
      COOKIE +
      "=" +
      value +
      "; Max-Age=15552000; Path=/; SameSite=Lax" +
      (window.location.protocol === "https:" ? "; Secure" : "");
  }
  return value;
};
export const clearVisitorId = () => {
  document.cookie = COOKIE + "=; Max-Age=0; Path=/; SameSite=Lax";
};
